import { useState, useCallback, useRef } from 'react'

export const useCalculateGridColumns = () => {
  const productCardRefs = useRef<HTMLElement[]>([])
  const [gridColumns, setGridColumns] = useState(0)

  const getProductGridRef = useCallback((node: HTMLUListElement | null) => {
    if (!node) return

    const handleResize = () => {
      const ulWidth = node.clientWidth
      const listItemWidths = productCardRefs.current
        .filter(Boolean)
        .slice(0, 12)
        .map((ref) => ref.closest('li')?.clientWidth || 0)
      const medianCardSize = findMedian(listItemWidths)
      if (ulWidth && medianCardSize) {
        setGridColumns(Math.round(ulWidth / medianCardSize))
      }
    }
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const getProductCardRef = useCallback((node: HTMLElement | null, index: number) => {
    if (!node) return
    productCardRefs.current[index] = node
  }, [])

  return { getProductGridRef, getProductCardRef, gridColumns }
}

function findMedian(array: number[]) {
  const sortedArray = [...array].sort((a, b) => a - b)
  if (sortedArray.length % 2 === 0) {
    // array with even number elements - get average of two middle values
    const mid1 = sortedArray[sortedArray.length / 2] ?? 0
    const mid2 = sortedArray[sortedArray.length / 2 - 1] ?? 0
    return (mid1 + mid2) / 2
  } else {
    // array with odd number elements
    return sortedArray[(sortedArray.length - 1) / 2]
  }
}
